/* ============================================================
   Plein5 — winkelwagen
   Aantal, verwijderen en aanbevelingen toevoegen, zonder dat de
   klant de lade uit hoeft. Na elke wijziging vragen we het thema
   om de lade opnieuw op te bouwen (cart:build), zodat totaal,
   verzendbalk, aanbevelingen en het bolletje bij het karretje
   allemaal tegelijk kloppen.
   ============================================================ */
(function () {
  'use strict';

  if (window.P5Cart) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function post(pad, body) {
    return fetch(root + pad, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  function haalCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function herbouw(cart) {
    document.dispatchEvent(new CustomEvent('cart:build'));
    if (cart) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    }
  }

  function melding(fout) {
    return (fout && (fout.description || fout.message)) || 'Dat lukte even niet. Probeer het nog eens.';
  }

  /* Eén regel kan uit meerdere producten bestaan: een kunstwerk met de
     lijst en het wandkleed als losse Globo-producten. Die zetten we altijd
     samen op hetzelfde aantal, en verwijderen we samen. Anders betaalt
     iemand voor twee kunstwerken maar één lijst. */
  function zetAantal(sleutels, aantal, regel) {
    var updates = {};
    sleutels.forEach(function (k) { updates[k] = aantal; });
    if (regel) regel.classList.add('is-busy');

    return post('cart/update.js', { updates: updates })
      .then(herbouw)
      .catch(function (fout) {
        if (regel) regel.classList.remove('is-busy');
        window.alert(melding(fout));
      });
  }

  function sleutelsVan(el) {
    return (el.getAttribute('data-p5c-keys') || '').split(',').filter(Boolean);
  }

  document.addEventListener('click', function (e) {
    /* Plus en min */
    var stap = e.target.closest('[data-p5c-step]');
    if (stap) {
      e.preventDefault();
      var doos = stap.closest('[data-p5c-keys]');
      if (!doos) return;
      var huidig = parseInt(doos.getAttribute('data-p5c-qty'), 10) || 1;
      var nieuw = huidig + parseInt(stap.getAttribute('data-p5c-step'), 10);
      if (nieuw < 1) return;
      zetAantal(sleutelsVan(doos), nieuw, doos.closest('.p5c-item'));
      return;
    }

    /* Verwijderen */
    var weg = e.target.closest('[data-p5c-remove]');
    if (weg) {
      e.preventDefault();
      zetAantal(sleutelsVan(weg), 0, weg.closest('.p5c-item'));
      return;
    }

    /* Aanbeveling toevoegen */
    var knop = e.target.closest('[data-p5c-add]');
    if (knop) {
      e.preventDefault();
      var kaart = knop.closest('.p5c-up__card');
      var keuze = kaart && kaart.querySelector('[data-p5c-variant]');
      var id = parseInt(keuze ? keuze.value : knop.getAttribute('data-variant'), 10);
      if (!id) return;

      var oud = kaart && kaart.querySelector('.p5c-up__fout');
      if (oud) oud.remove();

      knop.classList.add('is-busy');
      post('cart/add.js', { items: [{ id: id, quantity: 1 }] })
        .then(function () {
          knop.classList.remove('is-busy');
          knop.classList.add('is-klaar');
          knop.textContent = 'Toegevoegd';
          return haalCart();
        })
        .then(herbouw)
        .catch(function (fout) {
          knop.classList.remove('is-busy');
          if (kaart) {
            var p = document.createElement('p');
            p.className = 'p5c-up__fout';
            p.textContent = melding(fout);
            kaart.appendChild(p);
          }
        });
      return;
    }

    /* "Verder winkelen" sluit de lade */
    if (e.target.closest('[data-p5c-close]')) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('cart:close'));
    }
  });

  window.P5Cart = { zetAantal: zetAantal };
})();
